import { Component, DestroyRef, EventEmitter, inject, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { Menu } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { User } from '../../Interface/auth.interface';
import { AuthService } from '../../Services/auth.service';
import { HeaderService } from '../../Services/header.service';
import { LoaderService } from '../../Services/loader.service';
import { SidebarService } from '../../Services/sidebar.service';
import { TenantService } from '../../Services/tenant.service';
import { LoaderComponent } from '../loader/loader';

@Component({
  selector: 'app-header',
  imports: [CommonModule, Menu, AvatarModule, LoaderComponent, TooltipModule],
  templateUrl: './header.html',
})
export class Header {
  @Output() toggleSidebar = new EventEmitter<void>();
  private authService = inject(AuthService);
  private router = inject(Router);
  protected headerService = inject(HeaderService);
  public sidebarService = inject(SidebarService);
  public tenantService = inject(TenantService);
  private destroyRef = inject(DestroyRef);
  private loaderService = inject(LoaderService);

  onToggleSidebar(): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 1536) {
      this.sidebarService.toggleCollapse();
    } else {
      this.sidebarService.toggleDrawer();
      this.toggleSidebar.emit();
    }
  }

  get tenantName(): string {
    const user = this.authService.getUser<User>();
    return user?.tenant?.company_name || 'Tenant';
  }

  get userName(): string {
    const user = this.authService.getUser<User>();
    return user?.full_name || user?.email?.split('@')[0] || '';
  }

  get userEmail(): string {
    const user = this.authService.getUser<User>();
    return user?.email || '';
  }

  get currentIndustryLabel(): string {
    return this.tenantService.isPoolIndustryTenant() ? 'Pool Industry' : 'Medical Equipment';
  }

  get userMenuItems(): MenuItem[] {
    const user = this.authService.getUser<User>();
    const tenantName = user?.tenant?.company_name || 'Tenant';
    const email = user?.email || '';
    const isPool = this.tenantService.isPoolIndustryTenant();

    const items: MenuItem[] = [
      {
        label: tenantName,
        icon: 'pi pi-building text-primary text-xs',
        disabled: true,
        styleClass: 'font-semibold text-slate-900 text-xs opacity-100!',
      },
    ];

    if (email) {
      items.push({
        label: email,
        icon: 'pi pi-envelope text-slate-400 text-xs',
        disabled: true,
        styleClass: 'text-slate-500 text-xs opacity-90!',
      });
    }

    items.push(
      { separator: true },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        iconClass: '!text-red-500 dark:!text-red-400',
        linkClass: '!text-red-500 dark:!text-red-400',
        command: () => this.logout(),
      }
    );

    return items;
  }

  logout() {
    this.loaderService.show('header-loader');
    this.authService.logout();
    this.router.navigate(['/login']);
    this.loaderService.hide('header-loader');
  }
}
